import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, User } from 'lucide-react';

const testimonialsData = [
  {
    quote: "Advocate Rupam Kumari handled my case with exceptional dedication. Her knowledge of criminal law is outstanding.",
    client: "Rajesh Kumar, Patna"
  },
  {
    quote: "The team at NamoriSatya Legal provided expert guidance throughout my property dispute. Highly professional and reliable.",
    client: "Priya Singh, Delhi"
  },
  {
    quote: "I was impressed by the personalized attention and strategic approach. They truly understand their clients' needs.",
    client: "Amit Sharma, Bihar"
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonialsData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
  };

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="mb-8 flex justify-center">
            <div 
              className="w-20 h-20 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#F5F5F5' }}
            >
              <User className="h-10 w-10" style={{ color: '#555555' }} />
            </div>
          </div>

          <div className="relative min-h-[200px] flex items-center justify-center">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                className="space-y-6"
              >
                <p 
                  className="text-2xl md:text-3xl italic leading-relaxed"
                  style={{ color: '#1A1A1A' }}
                >
                  "{testimonialsData[currentIndex].quote}"
                </p>
                <p 
                  className="text-lg font-semibold"
                  style={{ color: '#2B2BFF' }}
                >
                  — {testimonialsData[currentIndex].client}
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex items-center justify-center space-x-4 mt-8">
            <button
              onClick={handlePrevious}
              className="p-2 rounded-full border-2 transition-all hover:scale-110"
              style={{ borderColor: '#2B2BFF', color: '#2B2BFF' }}
            >
              <ChevronLeft className="h-6 w-6" />
            </button>

            <div className="flex space-x-2">
              {testimonialsData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className="w-3 h-3 rounded-full transition-all"
                  style={{
                    backgroundColor: index === currentIndex ? '#2B2BFF' : '#E0E0E0'
                  }}
                />
              ))}
            </div>

            <button
              onClick={handleNext}
              className="p-2 rounded-full border-2 transition-all hover:scale-110"
              style={{ borderColor: '#2B2BFF', color: '#2B2BFF' }}
            >
              <ChevronRight className="h-6 w-6" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;